/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:767px){.body-content[_ngcontent-%COMP%]{padding-top:85px}}\n/*# sourceMappingURL=app.component.css.map*/"];
export { styles as styles };
